import Axios from "axios";

const axiosConfig = {
    baseURL: process.env.VUE_APP_API || '<api address not set>',
};

export default Axios.create(axiosConfig)

